import { createFileRoute, redirect } from "@tanstack/react-router";
import { AccessRequestPage } from "@/features/auth/access-request-page";
import { probeSession } from "@/hooks/data";

/** Sign-up = access request (ALP-85): staff review it; approved requesters sign in with the password they chose. */
export const Route = createFileRoute("/signup/")({
  beforeLoad: async ({ context }) => {
    const me = await probeSession(context.queryClient).catch(() => null); // QA F10: no 401 probe
    if (me) throw redirect({ to: "/home" });
  },
  head: () => ({ meta: [{ title: "Request access · Malfak" }, { name: "description", content: "Request access to Malfak: tell us about your business and we'll contact you." }] }),
  component: AccessRequestPage,
});
